/** @jsx jsx */

import React from 'react';

import { css, jsx } from '@emotion/core';

type ListProps = {
  /** List Item renderer */
  itemRenderer: (item: any, index: number) => React.ReactNode;
  /** List data */
  items: Array<any>;
  /** Gap Spacing for list items */
  gap?: number;
  /** Function that takes (item, index) and returns the row key */
  getKey?: (item: any, index: number) => string | number;
};

const getKeyDefault = (_item: any, index: number): number => index;

const defaultProps = {
  getKey: getKeyDefault,
};

const listCss = (gap?: number) =>
  css(
    {
      listStyleType: 'none',
      margin: 0,
      marginBlockEnd: 0,
      marginBlockStart: 0,
      padding: 0,
      paddingInlineStart: 0,
      WebkitMarginAfter: 0,
      WebkitMarginBefore: 0,
      WebkitPaddingStart: 0,
    },
    gap && {
      display: 'grid',
      gridGap: gap,
    }
  );

/**
 * A simple list that handles wrapping each item in an `li`.
 * Uses a renderer to create each item
 */
const List = ({
  itemRenderer,
  items,
  gap,
  getKey = getKeyDefault,
}: ListProps) => {
  const listItems = items.map((item, i) => (
    <li key={getKey(item, i)}>{itemRenderer(item, i)}</li>
  ));
  return <ul css={listCss(gap)}>{listItems}</ul>;
};

List.defaultProps = defaultProps;
export default List;
